import { render, staticRenderFns } from "./CriteriosRiesgoPreventa.vue?vue&type=template&id=0fcdb73c&scoped=true"
import script from "./CriteriosRiesgoPreventa.vue?vue&type=script&setup=true&lang=js"
export * from "./CriteriosRiesgoPreventa.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriteriosRiesgoPreventa.vue?vue&type=style&index=0&id=0fcdb73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcdb73c",
  null
  
)

export default component.exports